module.exports = __webpack_public_path__ + "img/logo.37eb408f.png";